import { TSlugName } from 'shared/typings';

export const getOptionsFromSlug = <T>(data: TSlugName[], map: T) => {
	return data
		.map(({ slug, name }) => ({
			value: slug,
			label: typeof map === 'function' ? map?.()?.[slug]?.name || map?.()?.[slug] || name : name,
		}))
		.sort((a, b) => a.label?.localeCompare(b.label));
};
